import { render, staticRenderFns } from "./SummaryWheel.vue?vue&type=template&id=69ece4ea&"
import script from "./SummaryWheel.vue?vue&type=script&lang=js&"
export * from "./SummaryWheel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports